import { FC, useState } from "react"

// components
import { InlineAlert, MegaphoneIcon } from "@eventbrite/marmalade"
import { Button } from "../Button/Button"

// data
import {
  InfoIcon,
  GlobeIcon,
  AlertOutlineIcon,
  FlagIcon,
  CheckIcon
} from "@eventbrite/marmalade"

// styles
import * as styles from "./Alert.module.scss"

// types
import {
  customRendererToRemovePTag,
  HelpArticleAlertData,
  renderRichText
} from "../../utils/contentful/render_rich_text"

type Props = {
  alertData: HelpArticleAlertData
}

const alertTypeMap: Record<
  string,
  {
    icon: JSX.Element
    variant: "info" | "success" | "warning" | "danger" | "opportunity"
  }
> = {
  Info: {
    icon: <InfoIcon size="medium" />,
    variant: "info"
  },
  Warning: {
    icon: <FlagIcon size="medium" />,
    variant: "warning"
  },
  Danger: {
    icon: <AlertOutlineIcon size="medium" />,
    variant: "danger"
  },
  Success: {
    icon: <CheckIcon size="medium" />,
    variant: "success"
  },
  Availability: {
    icon: <GlobeIcon size="medium" />,
    variant: "info"
  },
  Tip: {
    icon: <MegaphoneIcon size="medium" />,
    variant: "opportunity"
  }
}

export const Alert: FC<Props> = ({ alertData }) => {
  if (process.env.GATSBY_DEBUG === "true") {
    console.log("🚀 ~ alertData:", alertData)
  }

  const [isVisible, setIsVisible] = useState(true)

  const alertTypeKey = alertData?.alertTypeReference
    ?.alertTypeName as keyof typeof alertTypeMap
  const alertVariantInfo = alertTypeMap[alertTypeKey]
  const icon = alertVariantInfo?.icon
  const variant = alertVariantInfo?.variant

  if (!alertData?.alertDescription?.raw || !alertVariantInfo) {
    return null
  }
  if (!isVisible) {
    return null
  }

  return (
    <InlineAlert
      className={styles?.alertWrapper}
      title={alertData.alertHeader || ""}
      description={
        <>
          {renderRichText(
            alertData.alertDescription.raw,
            customRendererToRemovePTag
          )}
        </>
      }
      icon={alertData.alertShowIcon ? icon : undefined}
      variant={variant}
      closeOnClick={
        alertData?.alertDismissBoolean
          ? () => {
              setIsVisible(false)
            }
          : undefined
      }
      cta={
        alertData.alertCta?.microcopyValue?.raw ? (
          <Button variant="ghost">
            {renderRichText(
              alertData.alertCta?.microcopyValue?.raw || "",
              customRendererToRemovePTag,
              true
            )}
          </Button>
        ) : (
          <></>
        )
      }
    />
  )
}
